import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import ListItemIcon from '@mui/material/ListItemIcon'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import * as React from 'react'
import { useState } from 'react'
import { FileUploader } from 'react-drag-drop-files'
import { useInvalidateStorageInfo } from '../../../../api/hooks/useInvalidateStorageInfo'
import AddFolderIcon from '../../../../assets/icons/AddFolder.svg?react'
import FileIcon from '../../../../assets/icons/File.svg'
import PlusIcon from '../../../../assets/icons/Plus.svg'
import { FolderCreateDialog } from '../../../../dialogs/FolderCreateDialog'
import { useDiskStore } from '../../../../store/storeDisk'
import { useWrapperStore } from '../../../../store/storeWrapper'

export const CreateButton = ({ fileTypes, folder }) => {
    const { setIsRefreshFetchDisk } = useDiskStore((state) => state)
    const { uploadFiles, setRefreshStorage } = useWrapperStore((state) => state)
    const invalidateQueries = useInvalidateStorageInfo()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [openFolderCreateDialog, setOpenFolderCreateDialog] = useState(false)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClickChangeFiles = async (files) => {
        handleClose()
        await uploadFiles({ files }, folder)
        setIsRefreshFetchDisk(true)
        setRefreshStorage(true)
        invalidateQueries()
    }

    const handleClickOpenFolderCreateDialog = () => {
        handleClose()
        setOpenFolderCreateDialog(true)
    }
    const handleCloseFolderCreateDialog = () => {
        handleClose()
        setOpenFolderCreateDialog(false)
    }

    return (
        <>
            <Button
                onClick={handleClick}
                startIcon={<PlusIcon />}
                variant="contained"
                color="primary"
                sx={{
                    width: '100%',
                    textAlign: 'center',
                    display: 'flex',
                    my: 0,
                    zIndex: 1000,
                }}>
                Создать
            </Button>

            <Menu
                sx={{ width: '360px' }}
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}>
                <FileUploader
                    multiple={true}
                    types={fileTypes}
                    classes="upload-disk-file"
                    style={{
                        '&:focus-within': { outline: 'none' },
                    }}
                    handleChange={handleClickChangeFiles}
                    name="files"
                    id="files">
                    <MenuItem sx={{ alignItems: 'center' }}>
                        <ListItemIcon sx={{ ml: 2 }}>
                            <FileIcon />
                        </ListItemIcon>
                        <Typography variant="button">Загрузить файл</Typography>
                    </MenuItem>
                </FileUploader>
                <MenuItem sx={{ alignItems: 'center' }} onClick={handleClickOpenFolderCreateDialog}>
                    <ListItemIcon sx={{ ml: 2 }}>
                        <AddFolderIcon color="#004B9F" />
                    </ListItemIcon>
                    <Typography variant="button">Создать папку</Typography>
                </MenuItem>
            </Menu>
            <FolderCreateDialog
                folder={folder}
                open={openFolderCreateDialog}
                handleClose={handleCloseFolderCreateDialog}
            />
        </>
    )
}
